// src/data/loadTopics.js
// Lädt die Themen-Einträge (Zahlen, Wochentage, Monate, Uhrzeit …) einer Lernsprache aus
// public/data/<lang>_topics.csv (Semikolon-getrennt, Kopfzeile id;topic;<lang>;de).
// Felder wie bei den Sätzen: target = Lernsprache, src = Muttersprache (Deutsch).
// Fehlt die Datei, kommt eine leere Liste zurück.
import { cachedByLang, fetchLangCsvLines, headerIndex } from "./loadLangCsv";

export const loadTopics = cachedByLang(async (lang) => {
  const lines = await fetchLangCsvLines(lang, "topics");
  if (!lines) return [];

  const cols = headerIndex(lines[0]);
  if (
    cols.id === undefined ||
    cols.topic === undefined ||
    cols[lang] === undefined ||
    cols.de === undefined
  ) {
    throw new Error(`Ungültige Kopfzeile in ${lang}_topics.csv – erwartet: id;topic;${lang};de`);
  }

  return lines
    .slice(1)
    .map((line) => {
      const parts = line.split(";");
      const id = (parts[cols.id] || "").trim();
      const topic = (parts[cols.topic] || "").trim();
      const target = (parts[cols[lang]] || "").trim();
      if (!id || !topic || !target) return null;
      return { id, topic, target, src: (parts[cols.de] || "").trim() };
    })
    .filter(Boolean);
});
